// Applies the saved appearance before React renders, so the page never flashes the wrong theme.
try {
  const t = localStorage.getItem('noorview.theme');
  if (t === 'light' || t === 'dark' || t === 'legacy') document.documentElement.dataset.theme = t;
  if (localStorage.getItem('noorview.ui') === 'simple') document.documentElement.dataset.ui = 'simple';
} catch { /* storage unavailable: keep the default */ }
